<template>
  <vs-row>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-5 pb-4">Link WalletFlo Category with Plaid Categories</h3>
      </vs-row>
      <p class="pl-5 pb-6 pt-0 mb-2 whiteText">
        Here you can link your Plaid Category with it's corresponding WalletFlo
        Categories.
      </p>

      <vs-row class="">
        <vs-col vs-lg="12" vs-sm="6" class="">
          <vs-row>
            <vs-col vs-lg="12">
              <div class="my-2 ml-5">
                Plaid Category
              </div>
              <vs-input
                id="transparent"
                v-model="plaidCategoryName"
                class="w-full p-3 ml-2"
                :disabled="true"
              />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row>
        <div
          class="flex flex-wrap-reverse items-center ml-5 cursor mt-4 mb-3 pt-0"
          @click="addNewCategory"
        >
          <PlusSquareIcon color="white" />
          <h6 class="ml-2 mt-1 cursor">Add WalletFlo Subcategory</h6>
        </div>
      </vs-row>

      <div class="w-full">
        <transition-group type="transition" name="flip-list">
          <vs-row
            :key="index"
            v-for="(category, index) in point_Subcategories"
            class="ml-5"
          >
            <vs-col vs-lg="6" vs-sm="6" class="pr-6" id="inputBorder">
              <vs-row>
                <vs-col vs-lg="12">
                  <div class="my-2 pt-1 ml-1">
                    WalletFlo Subcategory {{ index + 1 }}
                  </div>

                  <select
                    v-if="points_categories_option.length >= 0"
                    v-model="point_Subcategories[index].name"
                    :class="{
                      'w-full posSelect  pl-3': true
                    }"
                    @change="handleSelect(index)"
                  >
                    <option selected>
                      {{ point_Subcategories[index].name }}
                    </option>
                    <option
                      v-for="categor in points_categories_option"
                      :key="categor._id"
                      :value="categor._id"
                    >
                      {{ categor.name }}
                    </option>
                  </select>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              vs-lg="3"
              vs-sm="3"
              vs-type="flex"
              vs-justify="flex-start"
              class="flex-col"
            >
              <div class="my-2 pt-1 ml-1">Points</div>
              <vs-input
                v-model="point_Subcategories[index].points"
                class="w-full mr-2"
              />
            </vs-col>
            <vs-col
              vs-lg="3"
              vs-sm="3"
              vs-type="flex"
              vs-justify="flex-end"
              class="flex-col"
            >
              <vs-button
                size="medium"
                class="mx-4"
                @click="viewCategoryDetails(point_Subcategories[index]._id)"
              >
                View Details
              </vs-button>
            </vs-col>
          </vs-row>
        </transition-group>
      </div>
      <vs-row v-if="errors.categories.success">
        <vs-col vs-lg="6" vs-sm="12" vs-type="flex" vs-justify="flex-start">
          <p class="text pt-5 pb-5 py-3 dangerColor">
            {{ errors.categories.msg }}
          </p>
        </vs-col>
      </vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="updateStatus.status"
      >
        <div class="mb-5">
          <h5>{{ updateStatus.msg }}</h5>
        </div>
        <div
          style="text-align: center; margin-top: 30px"
          vs-type="flex"
          vs-justify="center"
        >
          <vs-button
            class="mt-11"
            @click="toPlaidCategories()"
            color="primary"
            type="filled"
            >Show Plaid Categories</vs-button
          >
        </div>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="NoCategory.status"
        @close="closefunc()"
      >
        <h5>{{ NoCategory.msg }}</h5>
      </vs-popup>
    </vs-row>
    <vs-row class="mt-2 pr-10 pl-1" vs-justify="flex-end">
      <vs-button @click="updateCategories">Save</vs-button>
    </vs-row>
    <vs-popup
      class="holamundo"
      title="Select Point Categories"
      :active.sync="openAddCategoriesModel"
      @close="pointCategoriesModelClose()"
    >
      <vs-row>
        <vs-row class="my-5 mx-4">
          <vs-col vs-lg="8" vs-sm="12">
            <vs-row vs-type="flex" vs-justify="flex-start">
              <input
                maxLength="30"
                type="text"
                name="search"
                class="search px-4 w-1/3 py-3 shadow-lg"
                placeholder="Search..."
                @input="filterPointCategories"
                v-model="search"
              />
            </vs-row>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12">
            <vs-row vs-type="flex" vs-justify="flex-end">
              <vs-button
                class="pr-15 mr-1"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                :disabled="selected.length <= 0"
                @click="addCategoriesFromModel"
                >Add
              </vs-button>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="tblBgClrPending shadow-lg mx-4">
          <vs-table
            id="table1"
            multiple
            v-model="selected"
            :max-items="itemsPerPage"
            :data="points_categories_option"
            class="w-full"
            hoverFlat
          >
            <template slot="thead">
              <vs-th class="th-left-aligned" sort-key="popularity">
                CATEGORY NAME
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr
                  vs-align="center"
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                >
                  <vs-td>
                    <p class="font-medium">
                      {{ tr.name ? tr.name : "Not Available" }}
                    </p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vs-row>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon
  },

  data() {
    return {
      point_categories: "",

      plaid_category: null,
      points_categories_option: [],
      point_Subcategories: [],

      duplicate_point_categories_list: [],

      errors: {
        categories: {
          msg: "",
          success: false
        },

        duplicateIndices: []
      },

      updateStatus: {
        msg: "",
        status: false
      },
      NoCategory: {
        msg: "",
        status: false
      },
      genericErrorMessage,
      toast,
      openAddCategoriesModel: false,
      itemsPerPage: 10,
      selected: [],
      search: ""
    };
  },
  computed: {
    plaidCategoryName() {
      return this.plaid_category ? this.plaid_category.name : "";
    }
  },
  methods: {
    closeupdate() {
      this.updateStatus = {
        status: false,
        msg: ""
      };
    },
    async toPlaidCategories() {
      await this.closeupdate();
      this.$router.push({
        name: "plaid-categories"
      });
    },
    closefunc() {
      if (this.NoCategory.status == true) {
        this.NoCategory.status = false;
      } else {
        this.updateStatus = {
          status: false,
          msg: ""
        };
        this.$router.go(1);
      }
    },

    async filterPointCategories() {
      if (this.search.trim() != "") {
        this.points_categories_option = this.duplicate_point_categories_list.filter(
          item => item.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.points_categories_option = this.duplicate_point_categories_list;
      }
    },
    pointCategoriesModelClose() {
      this.search = "";
      this.selected = [];
      this.points_categories_option = this.duplicate_point_categories_list;
    },

    async addCategoriesFromModel() {
      if (this.selected.length > 0) {
        this.selected.forEach(_category => {
          this.point_Subcategories.push({
            _id: _category._id,
            name: _category.name
          });
          const indexOfCategory = this.points_categories_option.findIndex(
            val => val._id === _category._id
          );
          this.points_categories_option.splice(indexOfCategory, 1);
          this.point_Subcategories = this.point_Subcategories.map(
            (value, index) => {
              return {
                name: value.name,
                _id: value._id,
                points: value.points || 0
              };
            }
          );
        });
        this.openAddCategoriesModel = false;
        this.pointCategoriesModelClose();
      }
    },

    async addNewCategory() {
      this.duplicate_point_categories_list = this.points_categories_option;
      this.openAddCategoriesModel = true;
    },
    getCategories() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)"
      });
      return new Promise(resolve => {
        this.$axios
          .get(
            this.$ApiKeys.BASE_URL +
              this.$EndPoints.PointCategories +
              `?type=walletflo`
          )
          .then(async res => {
            this.$vs.loading.close();
            if (res.data.success) {
              resolve((this.points_categories_option = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },

    async getMainCategories(inp) {
      this.$vs.loading({ background: "rgba(1,2,3,.2)" });
      try {
        const res = await this.$axios.get(
          `${this.$ApiKeys.BASE_URL}${this.$EndPoints.PointCategories}?type=plaid-detailed&plaidCategoryId=${inp}`
        );
        this.$vs.loading.close();

        if (res.data.success) {
          this.getCategories();
          if (res.data.data.length > 0) {
            this.plaid_category = res.data.data[0].plaidCategory;
            if (res.data.data[0].categories.length > 0) {
              this.point_Subcategories = res.data.data[0].categories;
            }
          }
        } else {
          this.toast(this.genericErrorMessage());
        }
      } catch (e) {
        if (e.response && e.response.status !== 401) {
          this.toast(this.genericErrorMessage());
        }
        this.$vs.loading.close();
      }
    },
    async notempty() {
      for (var i = 0; i < this.point_Subcategories.length; i++) {
        if (
          this.point_Subcategories[i].name == "" ||
          !this.point_Subcategories[i].name.trim()
        ) {
          this.errors.categories = {
            msg: "Please fill out all the subcategories fields",
            success: true
          };
          return false;
        } else {
          this.errors.categories = {
            msg: "",
            success: false
          };
        }
      }
      return true;
    },
    async hasUniqueNames() {
      var tmpArr = [];
      for (var i = 0; i < this.point_Subcategories.length; i++) {
        if (tmpArr.indexOf(this.point_Subcategories[i].name) < 0) {
          tmpArr.push(this.point_Subcategories[i].name);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      // console.log('indices are: ',indices);
      return true;
    },
    viewCategoryDetails(categoryId) {
      this.$router.push({
        name: `plaid-subcategories`,
        params: { id: categoryId }
      });
    },
    async updateCategories() {
      this.hasUniqueNames(this.point_Subcategories);
      if (await this.notempty()) {
        if (await this.hasUniqueNames(this.point_Subcategories)) {
          this.errors.categories = {
            msg: "",
            success: false
          };
          let newVar = await this.point_Subcategories.map(value => {
            return { id: value._id, points: value.points || 0 };
          });
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$vs.loading.close();
            this.$vs.loading({
              background: "rgba(1,2,3,.2)"
            });
            return new Promise((resolve, reject) => {
              this.$axios
                .patch(
                  this.$ApiKeys.BASE_URL +
                    this.$EndPoints.PatchPlaidPointCategory(
                      this.plaid_category._id
                    ),
                  {
                    pointCategories: newVar
                  }
                )
                .then(async res => {
                  const errors =
                    res.data.response && res.data.response.errors
                      ? res.data.response.errors
                      : null;
                  this.$vs.loading.close();
                  if (res.data.success) {
                    this.updateStatus = {
                      msg: res.data.message,
                      status: true
                    };
                  } else if (errors && Array.isArray(errors) && errors.length) {
                    this.errors.categories = {
                      msg: errors[0],
                      success: true
                    };
                  } else {
                    this.toast(this.genericErrorMessage());
                  }
                })
                .catch(e => {
                  if (e.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
                  }
                  this.$vs.loading.close();
                  // console.log("Error in updateCategories: ",e);
                });
            });
          }, 500);
        } else {
          this.errors.categories = {
            msg: "Categories names must be unique.",
            success: true
          };
        }
      }
    },
    async handleSelect(inp) {
      if (this.point_Subcategories[inp].name != "") {
        this.errors.categories = {
          msg: "",
          success: false
        };
        const temp = this.point_Subcategories[inp]._id;

        let temp1 = this.points_categories_option.find(
          b => b._id == this.point_Subcategories[inp].name
        );
        if (temp1) {
          //this.point_Subcategories[inp].name = temp1.name;
          this.point_Subcategories[inp].name = temp1.name.replace(/\s+/g, " ");
          this.point_Subcategories[inp].name = this.point_Subcategories[
            inp
          ].name.replace(/^\s+|\s+$/g, "");

          this.point_Subcategories[inp]._id = temp1._id;
        }
        if (temp != this.point_Subcategories[inp]._id) {
          this.points_categories_option.splice(
            this.points_categories_option.findIndex(
              a => a._id == this.point_Subcategories[inp]._id
            ),
            1
          );
        }
      }
    }
  },
  mounted() {
    if (this.$route.params.id != undefined) {
      this.getMainCategories(this.$route.params.id);
    }
  }
};
</script>

<style>
#inputBorder {
  cursor: grab;
}
#inputBorder input {
  border-color: #1c1c1e !important;
}

.whiteText {
  color: white !important;
}
.con-vs-tooltip {
  margin-top: 20px;
  margin-left: 10px;
  /* padding-top: 20px; */
  /* background: green; */
}
.catBgClr {
  background-color: #1c1c1e;
  padding: 20px;
  border-radius: 10px;
}
.cursor {
  cursor: pointer;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
}
.manageButton {
  width: 207px;
  border-radius: 10, 21, 10, 21;
  font-size: 13px;
}
.posSelect {
  background-color: rgb(52, 52, 52) !important;
}

@media only screen and (min-width: 800px) {
  .text {
    margin-left: 35px;
    padding-left: 30px;
  }
}
@media only screen and (max-width: 800px) {
  .text {
    margin-left: 20px;
    padding-left: 10px;
  }
}
.vs-con-input {
  border: none;
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: hidden;
  outline: none;
}
.feather.feather-minus-square {
  color: #cacaca !important;
}

.tblBgClrPending {
  padding: 10px !important;
  background-color: #343434 !important;
}
.tblBgClrPending .vs-table,
.vs-table tbody tr {
  background-color: #2c2c2e !important;
  border-bottom: 10px solid #343434 !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}
.tblBgClrPending .vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 1rem;
  background-color: #2c2c2e !important;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 20px 15px;
  background-color: #343434 !important;
  font-size: 14px !important;
}
.vs-con-table .vs-con-tbody {
  margin-top: 20px;
}

.tblBgClrPending .vs-con-table td {
  border: none !important;
  padding: 20px 10px !important;
  padding-left: 15px !important;
}
.tblBgClrPending .vs-table--thead th .sort-th {
  display: none !important;
}
.search {
  border: none;
  border-radius: 6px;
  width: 462.5px !important;
  height: 38px !important;
}
</style>
